import { replaceStrategyPlayer, keepLockedInFormation } from '../../../service/strategyPlacement';
import { isSentOff, sentOffIds } from '../../../service/availability';
import * as action from '../../actions/Team';
import { liveMatchEnded, liveMatchUpdated } from '../../actions/Home';
import { handleActions } from '../../helpers/immer';
import { mergeLiveMatch } from '../../../service/liveMatch';
// import groupBy from "lodash/groupBy";

const initialValue = {
  playerToSell: null,
  seasonNumber: null,
  isPlayerLoading: false,
  areUnsavedChangesAvailable: false,
  myTeam: {
    academyList: [],
    playersListIds: [],
    allSquad: { players: [], seasonNumber: null, academyPlayers: [] },
    loading: false,
    listPlayerLoader: null,
    isReleaseLoading: false,
    effort: null,
    mindset: null,
    tactic: null,
  },
  strategy: {
    currentStrategy: '4-4-2',
    opponentStrategy: '4-4-2',
    isAutoFormatLoading: false,
    isAutoFormationEnabled: null,
    // True once GET /team/strategy carries Match Engine 2.5 fields; gates the live re-read.
    hasMatchEngine25: false,
    opponentName: null,
    allTeam: [],
    majorStaff: [],
    notMajorStaff: [],
    opponentSquad: [],
    upcomingCalendar: null,
    displayedSection: null,
    formationFilter: 'ALL',
    clickedPitchPlayerPosition: null,
    discordChannel: null,
    isOpponentPremium: null,
    teamKit: null,
    opponentKit: null,
    captain: {
      player: null,
      auto: false,
      change: { allowed: true, free: true, reason: 'first_pick' },
      seasonChangesLeft: 1,
      preview: { status: 'none', backing: null },
    },
    formationStyles: {
      byFormation: {
        '4-4-2': 'Direct',
        '4-3-3': 'Wide',
        '4-2-3-1': 'Wide',
        '4-5-1': 'Central',
        '3-5-2': 'Central',
        '4-4-1-1': 'Direct',
      },
      beats: {
        Wide: 'Central',
        Central: 'Direct',
        Direct: 'Wide',
      },
    },
    // Sample boost window so the meta row is designable before the API field lands.
    practiceBoostUntil: new Date(
      Date.now() + 6 * 60 * 60 * 1000
    ).toISOString(),
    hasCaptainField: true,
    hasFormationStyles: true,
    hasPracticeBoostUntil: true,
    selectedPlayer: {
      index: null,
      type: null,
    },
    tactics: { mindset: 0, effort: 0 },
    empty: {
      name: '-',
      first_name: '-',
      last_name: '-',
      fav_position: '-',
      current_position: '-',
      rating_range: null,
      potential: null,
      potential_range: null,
      form_range: null,
    },
    setTeam: {
      loading: false,
      competeLoading: false,
    },
    loading: true,
  },
  tips: {
    show: false,
  },
};
export const team = handleActions(
  {
    [action.loadPlayerInfo]: (draft) => {
      draft.isPlayerLoading = true;
      draft.playerToSell = null;
    },
    [action.addToList]: (draft, { payload }) => {
      draft.playerToSell = payload.player;
      draft.isPlayerLoading = false;
    },
    [action.removeFromList]: (draft) => {
      draft.playerToSell = null;
    },
    // ------------------SET STRATEGY-------------------
    [action.pickStrategy]: (draft, { payload }) => {
      draft.strategy.currentStrategy = payload.strategy;
      draft.strategy.allTeam = payload.newAll;
      draft.strategy.setTeam.competeLoading = false;
      // Sent-off lock: see removePlayerFromMajorStaff. A formation change must keep him in the XI.
      keepLockedInFormation(draft.strategy, payload.slots, sentOffIds(draft.strategy.matchRunning));
    },
    [action.pickOpponentStrategy]: (draft, { payload }) => {
      draft.strategy.opponentStrategy = payload.strategy;
      draft.strategy.setTeam.competeLoading = false;
    },
    [action.getOpponentStrategy]: (draft, { payload }) => {
      draft.strategy.opponentStrategy = payload.strategy;
    },
    // ------------------GET STRATEGY------------------
    [action.getMyStrategyLoading]: (draft) => {
      if (!draft.strategy.allTeam.length) {
        draft.strategy.loading = true;
      }
    },
    [action.getMyStrategy]: (draft, { payload }) => {
      draft.strategy.allTeam = payload.allTeam;
      draft.strategy.majorStaff = payload.inMainSquad;
      draft.strategy.notMajorStaff = payload.notInMainSquad;
      draft.strategy.opponentSquad = payload.opponentPlayers;
      draft.strategy.currentStrategy = payload.teamFormation;
      draft.strategy.opponentName = payload.opponentName;
      draft.strategy.opponentStrategy = payload.opponentLastFormation;
      draft.strategy.tactics = payload.tactics;
      draft.strategy.upcomingCalendar = payload.upcomingCalendar;
      draft.strategy.isAutoFormationEnabled = payload.isAutoFormationEnabled ?? null;
      draft.strategy.matchRunning =
        payload.matchRunning && draft.strategy.matchRunning
          ? mergeLiveMatch(draft.strategy.matchRunning, payload.matchRunning)
          : payload.matchRunning;
      draft.strategy.discordChannel = payload.discordChannel;
      draft.strategy.isOpponentPremium = payload.isOpponentPremium;
      draft.strategy.teamKit = payload.teamKit;
      draft.strategy.opponentKit = payload.opponentKit;
      draft.strategy.hasMatchEngine25 = Boolean(payload.hasMatchEngine25);
      if (payload.hasCaptainField || payload.hasMatchEngine25) {
        draft.strategy.captain = payload.captain ?? draft.strategy.captain;
        draft.strategy.hasCaptainField = true;
      } else if (payload.captain !== undefined) {
        draft.strategy.captain = payload.captain ?? draft.strategy.captain;
      }
      if (payload.hasFormationStyles) {
        draft.strategy.formationStyles = payload.formationStyles;
        draft.strategy.hasFormationStyles = true;
      }
      if (payload.hasPracticeBoostUntil) {
        draft.strategy.practiceBoostUntil = payload.practiceBoostUntil;
        draft.strategy.hasPracticeBoostUntil = true;
      }

      draft.strategy.loading = false;
    },
    [action.setStrategyCaptain]: (draft, { payload }) => {
      draft.strategy.captain = payload;
      draft.strategy.hasCaptainField = true;
    },
    [action.captainUpdated]: (draft, { payload }) => {
      draft.strategy.captain = payload ?? null;
    },
    [action.liveStrategyRefreshed]: (draft, { payload }) => {
      draft.strategy.matchRunning =
        payload.matchRunning && draft.strategy.matchRunning
          ? mergeLiveMatch(draft.strategy.matchRunning, payload.matchRunning)
          : payload.matchRunning;
    },

    [action.setAutoFormationVal]: (draft, { payload }) => {
      draft.strategy.isAutoFormationEnabled = payload;
    },
    [action.autoFormationLoading]: (draft, { payload }) => {
      draft.strategy.isAutoFormatLoading = payload;
    },
    [action.setAutoFormationList]: (draft, { payload }) => {
      draft.strategy.allTeam = payload.allTeam;
      draft.strategy.majorStaff = payload.inMainSquad;
      draft.strategy.notMajorStaff = payload.notInMainSquad;
      draft.strategy.isAutoFormatLoading = false;
    },
    // ------------------REQUEST FOR NEXT MATCH---------
    [action.setRequestForSaveStrategyLoading]: (draft) => {
      draft.strategy.setTeam.loading = true;
    },
    [action.createRequestForSaveStrategy]: (draft, { payload }) => {
      draft.strategy.setTeam.loading = false;
      draft.strategy.setTeam.competeLoading = payload.competeLoading;
      draft.strategy.selectedPlayer = { index: null, type: null };
    },
    [action.updateStrategyData]: (draft) => {
      draft.strategy.setTeam.loading = false;
      draft.strategy.setTeam.competeLoading = false;
    },
    // ------------------TEAM----------------------
    [action.getMyTeamLoading]: (draft) => {
      if (!draft.myTeam.allSquad.players.length) {
        draft.myTeam.loading = true;
      }
    },
    [liveMatchUpdated]: (draft, { payload }) => {
      if (!draft.strategy.matchRunning) return;
      draft.strategy.matchRunning = mergeLiveMatch(
        draft.strategy.matchRunning,
        payload
      );
    },
    [liveMatchEnded]: (draft) => {
      draft.strategy.matchRunning = null;
    },
    [action.setUnsavedChanges]: (draft, { payload }) => {
      draft.areUnsavedChangesAvailable = payload;
    },
    [action.setSeason]: (draft, { payload }) => {
      draft.seasonNumber = payload;
    },

    [action.getMyTeam]: (draft, { payload }) => {
      draft.myTeam.allSquad.academyPlayers = payload.academyPlayers;
      draft.myTeam.allSquad.players = payload.allPlayers;
      draft.myTeam.allSquad.seasonNumber = payload.seasonNumber;
      draft.myTeam.loading = false;
      draft.myTeam.academyList = payload.academyList;
    },
    [action.setSelectedListIds]: (draft, { payload }) => {
      draft.myTeam.playersListIds = payload.list;
    },
    [action.removePlayerFromMajorStaff]: (draft, { payload }) => {
      // Sent-off lock (Match Engine 2.5): a player sent off in the running match stays in the XI
      // until full time, and POST /team/strategy refuses a lineup without him (403). Every way of
      // taking a player out of the XI ends here: a drop on the player list, Clear all and the
      // remove buttons. The buttons are disabled for him too; this keeps any path that reaches
      // the reducer honest. With no red cards in matchRunning (today's API) nothing is locked.
      if (isSentOff(draft.strategy.matchRunning, payload)) return;
      const filteredSquad = draft.strategy.majorStaff.filter(
        (player) => player._id !== payload
      );
      const removed = draft.strategy.allTeam.find((player) => player._id === payload);
      if (removed) removed.main = false;
      draft.strategy.selectedPlayer.index = null;
      draft.strategy.majorStaff = filteredSquad;
    },
    // draft.strategy.majorStaff[draft.strategy.selectedPlayer.index].id
    // -------------------GET TIPS----------------------

    [action.showExpertTips]: (draft, { payload }) => {
      draft.tips.show = payload.state;
    },
    // ------------------SELECT CURRENT PLAYER-------------
    [action.selectPlayerOnGameField]: (draft, { payload }) => {
      // console.log("Selected ",payload.player)

      const indexInData = draft.strategy.majorStaff.findIndex(
        (element) => element._id === payload.player._id
      );
      // const indexInAll=draft.strategy.allTeam.findIndex(
      //     (element) => element.id === payload.player.id
      //   );
      if (indexInData !== -1) {
        // IF YOU PICK NOT AN EMPTY PLAYER
        // console.log("PICK NOT AN EMPTY PLAYER",indexInData)
        // draft.strategy.allTeam[indexInAll].main=true;
        draft.strategy.selectedPlayer.index = indexInData;
        draft.strategy.selectedPlayer.type = payload.player.current_position;
      } else {
        // console.log("PICK AN EMPTY",payload.player)
        // IF YOU PICK AN EMPTY PLAYER
        draft.strategy.selectedPlayer.index = null;
        draft.strategy.selectedPlayer.type = payload.player.current_position;
      }
      // if (payload.player.data) {
      // const indexInData = draft.myTeam.allSquad.findIndex(
      //   (element) => element.name === payload.player.data.name
      // );
      // if (indexInData !== -1) draft.myTeam.selectedPlayer.index = indexInData;
      // } else {
      //   draft.myTeam.selectedPlayer.index = null;
      // }
      // draft.myTeam.selectedPlayer.type = payload.player.type;
    },
    // -----------------REPLACE PLAYER IN MAIN TEAM ARRAY------
    [action.clickedPitchPlayerPosition]: (draft, { payload }) => {
      if (payload === null) {
        draft.strategy.clickedPitchPlayerPosition = null;
      } else {
        draft.strategy.clickedPitchPlayerPosition = payload;
      }
    },
    [action.replacePlayerFromTheirPosition]: (draft, { payload }) => {
      // Sent-off lock: see removePlayerFromMajorStaff. Swaps and replacements may move him, not bench him.
      replaceStrategyPlayer(draft.strategy, payload.player, sentOffIds(draft.strategy.matchRunning));
    },
    // -----------------LIST PLAYER LOGIC------------------
    [action.listPlayerLoader]: (draft) => {
      draft.myTeam.listPlayerLoader = true;
      draft.playerToSell.isLoading = true;
    },
    [action.listPlayer]: (draft, { payload }) => {
      if (payload.playerID) {
        const field = payload.field === 'listed_loan' ? 'listed_loan' : 'listed';
        const indexInData = draft.myTeam.allSquad.players.findIndex(
          ({ _id }) => _id === payload.playerID
        );
        if (indexInData !== -1) {
          draft.myTeam.allSquad.players[indexInData][field] = payload.status;
          if (draft.playerToSell?._id === payload.playerID) {
            draft.playerToSell[field] = payload.status;
          }
          draft.myTeam.listPlayerLoader = false;
          if (draft.playerToSell) draft.playerToSell.isLoading = false;
        }
      }
    },
    [action.listPlayerError]: (draft) => {
      draft.myTeam.listPlayerLoader = false;
      draft.playerToSell.isLoading = false;
    },
    [action.releasePlayerLoading]: (draft, { payload }) => {
      draft.myTeam.isReleaseLoading = payload;
    },
    [action.removePlayer]: (draft, { payload }) => {
      const newData = draft.myTeam.allSquad.players.filter(
        (player) => player._id !== payload
      );
      draft.myTeam.allSquad.players = newData;
    },
    // Formation save
    [action.setTactic]: (draft, { payload }) => {
      draft.myTeam.tactic = payload;
    },
    [action.setMindset]: (draft, { payload }) => {
      draft.strategy.tactics.mindset = payload;
    },
    [action.setEffort]: (draft, { payload }) => {
      draft.strategy.tactics.effort = payload;
    },
    [action.setFormationFilter]: (draft, { payload }) => {
      draft.strategy.formationFilter = payload;
    },
    // Mobile team sidebar
    [action.showMobileSection]: (draft, { payload }) => {
      draft.strategy.displayedSection = payload;
    },
    // Player Edit
    [action.editSelectedPlayerData]: (draft, { payload }) => {
      // Make this change on UI to be aligned with actual BE data until user wil reload page
      const newData = draft.myTeam.allSquad.players.map((player) =>
        player._id === payload.id
          ? { ...player, ...payload.dataToChange }
          : player
      );
      draft.myTeam.allSquad.players = newData;
      const updatedPlayerToSell = {
        ...draft.playerToSell,
        ...payload.dataToChange,
      };
      draft.playerToSell = updatedPlayerToSell;
    },
    [action.setToAcademyAction]: (draft, { payload }) => {
      draft.myTeam.academyList = [...draft.myTeam.academyList, payload];
    },
  },
  initialValue
);
